"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/get");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var utils_1 = require("../utils");

var Sto_1 = require("./Sto");

var procedures_1 = require("../procedures");

var Investment_1 = require("./Investment");

var weiToValue = contract_wrappers_1.conversionUtils.weiToValue;
/**
 * Class used to manage a simple sto
 */

var SimpleSto =
/*#__PURE__*/
function (_Sto_1$Sto) {
  _inherits(SimpleSto, _Sto_1$Sto);

  _createClass(SimpleSto, null, [{
    key: "generateId",

    /**
     * Generate the Simple STO's UUID from its identifying properties
     */
    value: function generateId(_ref) {
      var securityTokenId = _ref.securityTokenId,
          stoType = _ref.stoType,
          address = _ref.address;
      return utils_1.serialize('simpleSto', {
        securityTokenId: securityTokenId,
        stoType: stoType,
        address: address
      });
    }
    /**
     * Create a new simple sto instance
     */

  }]);

  function SimpleSto(params, context) {
    var _this;

    _classCallCheck(this, SimpleSto);

    var cap = params.cap,
        rate = params.rate,
        rest = __rest(params, ["cap", "rate"]);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SimpleSto).call(this, rest, context));
    var securityTokenId = rest.securityTokenId,
        address = rest.address,
        stoType = rest.stoType;
    _this.cap = cap;
    _this.rate = rate;
    _this.uid = SimpleSto.generateId({
      address: address,
      stoType: stoType,
      securityTokenId: securityTokenId
    });
    return _this;
  }
  /**
   * Retrieve all investments that have been made on this STO
   */


  _createClass(SimpleSto, [{
    key: "getInvestments",
    value: function getInvestments() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this$context, contractWrappers, factories, address, symbol, securityTokenId, stoId, module, tokenPurchases, investments, investmentEntities;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$context = this.context, contractWrappers = _this$context.contractWrappers, factories = _this$context.factories, address = this.address, symbol = this.securityTokenSymbol, securityTokenId = this.securityTokenId, stoId = this.uid;
                _context.next = 3;
                return contractWrappers.moduleFactory.getModuleInstance({
                  name: contract_wrappers_1.ModuleName.CappedSTO,
                  address: address
                });

              case 3:
                module = _context.sent;
                _context.next = 6;
                return module.getLogsAsync({
                  eventName: contract_wrappers_1.CappedSTOEvents.TokenPurchase,
                  blockRange: {
                    fromBlock: contract_wrappers_1.BlockParamLiteral.Earliest,
                    toBlock: contract_wrappers_1.BlockParamLiteral.Latest
                  },
                  indexFilterValues: {}
                });

              case 6:
                tokenPurchases = _context.sent;
                investments = tokenPurchases.map(function (_ref2, index) {
                  var _ref2$args = _ref2.args,
                      beneficiary = _ref2$args.beneficiary,
                      amount = _ref2$args.amount,
                      value = _ref2$args.value;
                  return {
                    address: beneficiary,
                    tokenAmount: weiToValue(amount, contract_wrappers_1.FULL_DECIMALS),
                    investedFunds: weiToValue(value, contract_wrappers_1.FULL_DECIMALS),
                    index: index
                  };
                });
                investmentEntities = investments.map(function (_a) {
                  var index = _a.index,
                      investment = __rest(_a, ["index"]);

                  return factories.investmentFactory.create(Investment_1.Investment.generateId({
                    securityTokenId: securityTokenId,
                    stoId: stoId,
                    index: index
                  }), Object.assign({
                    securityTokenSymbol: symbol
                  }, investment));
                });
                return _context.abrupt("return", investmentEntities);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Invest in the STO
     *
     * @param args.amount - amount to spend
     * @param args.beneficiary - address that will receive the purchased tokens (defaults to current wallet, will fail if beneficial investments are not allowed for the STO, only applicable if the STO currency is ETH)
     */

  }, {
    key: "invest",
    value: function invest(args) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var stoAddress, symbol, procedure;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                stoAddress = this.address, symbol = this.securityTokenSymbol;
                procedure = new procedures_1.InvestInSimpleSto(Object.assign({
                  stoAddress: stoAddress,
                  symbol: symbol
                }, args), this.context);
                return _context2.abrupt("return", procedure.prepare());

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * Convert entity to a POJO (Plain Old Javascript Object)
     */

  }, {
    key: "toPojo",
    value: function toPojo() {
      var stoPojo = _get(_getPrototypeOf(SimpleSto.prototype), "toPojo", this).call(this);

      var cap = this.cap,
          rate = this.rate;
      return Object.assign({}, stoPojo, {
        cap: cap,
        rate: rate
      });
    }
    /**
     * Hydrate the entity
     */

  }, {
    key: "_refresh",
    value: function _refresh(params) {
      var cap = params.cap,
          rate = params.rate,
          rest = __rest(params, ["cap", "rate"]);

      if (cap) {
        this.cap = cap;
      }

      if (rate) {
        this.rate = rate;
      }

      _get(_getPrototypeOf(SimpleSto.prototype), "_refresh", this).call(this, rest);
    }
  }]);

  return SimpleSto;
}(Sto_1.Sto);

exports.SimpleSto = SimpleSto;